module.exports = __webpack_public_path__ + "static/media/sample_rake_planning_bulk_upload_new.b8a1f19f.csv";